import { EventArgs } from "react-ga";
import { LangHistory } from "utils/History";
import Mixpanel from "landings/Analytics/Mixpanel";
import DataReporter from "./DataReporter";
import LocalStorageUtils from "utils/LocalStorageUtils";

const gtagReporter = DataReporter.reporters.gtag;

/**
 * @deprecated 老的google统计调用方式，使用 {@link DataReporter}同时上报多个平台
 */
export class AnalyticsTool {
    static init(history: LangHistory) {
        const win = window as any;
        if (win.webStartTime) {
            win.webReadyTime = Date.now();
            AnalyticsTool.trackingEvent({
                category: "pionex_page_load_time",
                action: history.location.pathname,
                value: win.webReadyTime - win.webStartTime,
            });
        }
    }

    /**
     * @deprecated Use {@link gtagReporter.report} instead.
     * @param event
     */
    static trackingEvent(event: EventArgs) {
        let { category, action, ...rest } = event;
        try {
            let actionData = JSON.parse(action) as any;
            if (typeof !action === "object") {
                actionData = { action };
            }
            gtagReporter.report(category, { ...rest, ...actionData });
        } catch (e) {}
    }

    static trackUserDownloadApp(source: string) {
        DataReporter.report("go_download_app", { position: source, ref: LocalStorageUtils.getReferralCode() });
    }
}
